/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_TitleInputs */

const vi_my_grower_report_title = /** @type {(inputs: My_Grower_Report_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Báo cáo`)
};

/**

* @param {My_Grower_Report_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_title = /** @type {((inputs?: My_Grower_Report_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_title(inputs)
});